import React, { useEffect } from "react";
import './Navigation.css';
import logo from "../assets/logos.png";

export const Navigation = (props) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11544954076";
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', 'AW-11544954076');
    };

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            <img src={logo} alt="free" />
          </a>
        </div>

        <div
          className="collapse navbar-collapse red-background"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#about" className="page-scroll">
                About
              </a>
            </li>
            <li>
              <a href="#amenities" className="page-scroll">
                Amenities
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                Products
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll">
                Gallery
              </a>
            </li>
            <li>
              <a href="#location" className="page-scroll">
                location
              </a>
            </li>
            <li>
              <a href="tel:+917090461000" className="page-scroll" style={{ color: "red" }}>
                <span style={{ fontWeight: "800", fontSize: "16px" }}>Call: 7090461000</span>
              </a>
            </li>
            <li>
              <a href="#master" className="page-scroll">
                Master Plan
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
